import axios from "./axios";

export async function fetchTextMessages(controller) {
  return axios({ method: "get", url: "/text_messages/", params: controller });
}

export async function createTextMessage(payload) {
  return axios.post(`/text_messages/`, { text_message: payload });
}
